module.exports = __webpack_public_path__ + "img/icons_15.dec8474e.svg";